var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.17,
    height: 54.615,
    viewBox: "0 0 45.17 54.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148003",
    "data-name": "Rectangle 148003",
    width: 45.17,
    height: 54.615,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144871",
    "data-name": "Group 144871",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148002",
    "data-name": "Rectangle 148002",
    width: 45.17,
    height: 54.615,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_144870",
    "data-name": "Group 144870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144869",
    "data-name": "Group 144869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M39.464,43.967l-10.92-2.895h-1.1V38.392a10.946,10.946,0,0,0,5.427-6.344,1.226,1.226,0,0,0,.2.021c1.3,0,2.353-2.156,2.353-4.814,0-2.459.3-4.753-.681-5.079.739-3.474,1.264-8.625-1.8-12.463-1.481-1.855-7.215-3.105-7.215-3.105l1.256-1.86L23.212,6.3V4.124a7.961,7.961,0,0,1-5.333,3.105c-3.764.62-6.587,6.209-6.9,7.761a47.8,47.8,0,0,0,.51,7.378,1.828,1.828,0,0,0-.809-.237c-1.3,0-.941,2.465-.941,5.123s1.053,4.814,2.351,4.814a1.189,1.189,0,0,0,.2-.021,10.954,10.954,0,0,0,5.428,6.344v2.681h-.777L6.566,43.923A8.89,8.89,0,0,0,0,52.475v3.19H46.111V52.541a8.891,8.891,0,0,0-6.646-8.573",
    transform: "translate(0 2.132)",
    fill: "#bdc4c6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passportIcon.25577d4afddc5f5e1e2e115789e9e7e9.svg";
export { ForwardRef as ReactComponent };